import type { InsertUserGroupUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertUserGroupUsersDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertUserGroupUsersInput = {
  objects: { UserGroupId: string; UserId: string }[];
};

export const useInsertUserGroupUsers = createMutationHook({
  name: 'insertUserGroupUsers',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userGroup.insertUsers.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertUserGroupUsersInput) => variables,
  invalidate: (trpc) => [
    trpc.frontend.userGroup.usersByGroupId.queryKey(),
    trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
    trpc.frontend.userGroup.userGroupById.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): InsertUserGroupUsersMutation => ({
    insert_user_group_user: {
      __typename: 'user_group_user_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: InsertUserGroupUsersDocument,
  graphqlVariables: (variables: InsertUserGroupUsersInput) => ({
    ...variables,
  }),
  evictFields: ['user_group_user', 'user_group'],
});
